var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "slide" } },
    [
      _c(
        "b-navbar",
        {
          class: _vm.headerClassBindings,
          attrs: { toggleable: "", fixed: "top", variant: "faded" }
        },
        [
          _c(
            "div",
            { staticClass: "container app-header-container" },
            [
              _c("b-nav-toggle", {
                staticClass: "clickable",
                attrs: { target: "scroll-app-header-nav-collapse" }
              }),
              _vm._v(" "),
              _vm.attachHome
                ? _c(
                    "b-link",
                    {
                      staticClass: "navbar-brand app-brand",
                      attrs: { to: "/intro" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-classting-logo.svg" }
                      })
                    ]
                  )
                : _c(
                    "b-link",
                    {
                      staticClass: "navbar-brand app-brand",
                      attrs: { to: "/library" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-classting-logo.svg" }
                      })
                    ]
                  ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  attrs: { "is-nav": "", id: "scroll-app-header-nav-collapse" }
                },
                [
                  _c(
                    "b-nav",
                    { staticClass: "mx-auto", attrs: { "is-nav-bar": "" } },
                    [
                      _c("b-nav-item", { attrs: { to: "/library" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.library")))
                      ]),
                      _vm._v(" "),
                      _c("b-nav-item", { attrs: { to: "/my-cards" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.my_cards")))
                      ]),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? _c("b-nav-item", { attrs: { to: "/publishers" } }, [
                            _vm._v(_vm._s(_vm.$t("header.nav_menu.publishers")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? _c(
                            "b-nav-item",
                            { attrs: { to: "/video-courses" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("header.nav_menu.video_lectures"))
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav",
                    {
                      staticClass: "hidden-sm-down",
                      attrs: { "is-nav-bar": "" }
                    },
                    [
                      _c("a", {
                        staticClass: "btn rounded-circle profile-btn",
                        style: _vm.styleBindings,
                        attrs: { href: _vm.userProfileUrl, target: "_blank" }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48717d41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48717d41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollAppHeader.vue
// module id = BsW3
// module chunks = 1